const UrlLinkComponent = {
    templateUrl: '/formViewer/component/urlLink/urlLink.tpl.html',
    controller: 'urlLinkController',
    bindings: {
        fieldStructure: '<'
    }
};

angular.module('umFormViewer')
    .component('uiUrlLink', UrlLinkComponent);
